module.exports = fox._r("fonts/tags-filter.ttf?3lzqzp", __webpack_public_path__ + "_/_/_/root/fonts/1MWRmpt.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/tags-filter.ttf?3lzqzp
// module id = 425
// module chunks = 4